import React from 'react';
import { Box } from '@mui/material';

// The assistant's face.
//
// A picture rather than something drawn in code, because this one was given to us and is the
// product's own. It is a transparent circular badge carrying its own dark ground, so it reads on a
// light page and a dark one alike without a second copy, and nothing here clips or tints it: the
// corners are already transparent, and cutting a circle out of art that is not quite one is how a
// badge loses its edge.
//
// Served from the page's own files rather than imported, so every place it appears - the launcher,
// the panel header, each answer - is one cached request at one size, instead of a separate hashed
// copy per import. The file is 128 pixels and 27KB, which is a quarter of what the product's other
// marks cost: it is drawn no larger than 48 anywhere, and a phone at a plant gate pays for every
// byte of the first load.
//
// Decorative wherever the assistant is also named beside it, which is everywhere it currently
// appears, so it carries no alternative text by default - a screen reader announcing the name twice
// is worse than announcing it once.

const AssistantMark = ({ size = 24, label = '' }) => (
  <Box
    component="img"
    src="/assistant.png"
    alt={label}
    width={size}
    height={size}
    sx={{ display: 'block', flexShrink: 0 }}
  />
);

export default AssistantMark;
